// The scaffold rail is desktop-only. Below 1280px the panel must
// unmount (return null) so a live AgentChat cannot keep running
// behind `display: none`. CSS is not the gate.

import { useEffect, useState } from 'react';

export const AGENT_PANEL_MIN_WIDTH_PX = 1280;

export function useAgentPanelViewport(): boolean {
  const query = `(min-width: ${AGENT_PANEL_MIN_WIDTH_PX}px)`;
  const [wide, setWide] = useState(() => readWide(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const sync = () => setWide(mql.matches);
    sync();
    mql.addEventListener('change', sync);
    return () => mql.removeEventListener('change', sync);
  }, [query]);

  return wide;
}

function readWide(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
}
